var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlertErrorRedBold(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6444_1583)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.99967 8.88954V4.00065M8.02702 11.1673C7.96071 11.1673 7.89713 11.141 7.85024 11.0941C7.80336 11.0472 7.77702 10.9836 7.77702 10.9173C7.77702 10.851 7.80336 10.7874 7.85024 10.7405C7.89713 10.6937 7.96071 10.6673 8.02702 10.6673C8.09332 10.6673 8.15691 10.6937 8.20379 10.7405C8.25068 10.7874 8.27702 10.851 8.27702 10.9173C8.27702 10.9836 8.25068 11.0472 8.20379 11.0941C8.15691 11.141 8.09332 11.1673 8.02702 11.1673ZM7.99967 14.6673C11.6815 14.6673 14.6663 11.6824 14.6663 8.00065C14.6663 4.31887 11.6815 1.33398 7.99967 1.33398C4.3179 1.33398 1.33301 4.31887 1.33301 8.00065C1.33301 11.6824 4.3179 14.6673 7.99967 14.6673Z",
    stroke: "#C12010",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6444_1583"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertErrorRedBold);
export default __webpack_public_path__ + "static/media/alert-error-red-bold.43e9e0809847d203be027109b4dcb975.svg";
export { ForwardRef as ReactComponent };